export const docContainerSize = 768;
export const blogContainerSize = 1152;
